import * as React from "react";
import { forwardRef } from "react";
const SvgTopuserStar = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 6, height: 6, fill: "none", viewBox: "0 0 6 6", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#EA5278", d: "M3 0s.16 1.548.806 2.194S6 3 6 3s-1.548.16-2.194.806S3 6 3 6s-.16-1.548-.806-2.194S0 3 0 3s1.548-.16 2.194-.806S3 0 3 0" }));
const ForwardRef = forwardRef(SvgTopuserStar);
export { ForwardRef as ReactComponent };
